import React, { useEffect, useState } from 'react';
import {
  Facebook,
  Instagram,
  Share2,
  //  Link as LinkIcon
} from 'lucide-react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import Nav from '../../Nav/Nav';
import ScrollTop from '../../Scrolltop';

// import { iphoneProductDetails } from '../../../redux/Apple/iphone/iphoneProductDetails';

import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import RedirectBack from '../../../resuable/RedirectBack';
import ultra3DetailImage1 from '../../../assets/apple/iWatch/Ultra3XDetails/Ultra3_1.png';
import ultra3DetailImage2 from '../../../assets/apple/iWatch/Ultra3XDetails/Ultra3_2.png';
import ultra3DetailImage3 from '../../../assets/apple/iWatch/Ultra3XDetails/Ultra3_3.png';
import ultra3DetailImage4 from '../../../assets/apple/iWatch/Ultra3XDetails/Ultra3_4.png';
import ultra3DetailImage5 from '../../../assets/apple/iWatch/Ultra3XDetails/Ultra3_5.png';
import ultra3DetailImage6 from '../../../assets/apple/iWatch/Ultra3XDetails/Ultra3_6.png';
import ultra3DetailImage7 from '../../../assets/apple/iWatch/Ultra3XDetails/Ultra3_7.png';
import ultra3DetailImage8 from '../../../assets/apple/iWatch/Ultra3XDetails/Ultra3_8.png';
import ultra3DetailImage9 from '../../../assets/apple/iWatch/Ultra3XDetails/Ultra3_9.png';
import ultra3DetailImage10 from '../../../assets/apple/iWatch/Ultra3XDetails/Ultra3_10.png';
import s26UltraHighlight1 from '../../../assets/samsungStore/GalaxyS26/S26ultra/Highlights/S26Ultra1.png';
import s26UltraHighlight2 from '../../../assets/samsungStore/GalaxyS26/S26ultra/Highlights/S26Ultra2.png';
import s26UltraHighlight3 from '../../../assets/samsungStore/GalaxyS26/S26ultra/Highlights/S26Ultra3_1.png';
import s26UltraHighlight4 from '../../../assets/samsungStore/GalaxyS26/S26ultra/Highlights/S26Ultra4.png';
import s26UltraHighlight5 from '../../../assets/samsungStore/GalaxyS26/S26ultra/Highlights/S26Ultra5.png';
import s26UltraHighlight6 from '../../../assets/samsungStore/GalaxyS26/S26ultra/Highlights/S26Ultra6.png';
import s26UltraHighlight7 from '../../../assets/samsungStore/GalaxyS26/S26ultra/Highlights/S26Ultra7.png';
import s26UltraHighlight8 from '../../../assets/samsungStore/GalaxyS26/S26ultra/Highlights/S26Ultra8.png';
import s26Info1 from '../../../assets/samsungStore/GalaxyS26/S26/S26/DetailsImage/s26_info1.png';
import s26Info2 from '../../../assets/samsungStore/GalaxyS26/S26/S26/DetailsImage/s26_info2.png';
import s26Info5 from '../../../assets/samsungStore/GalaxyS26/S26/S26/DetailsImage/s26_info5.png';

export default function IphoneDetailPage() {
  // /////////////////////////////////////////////
  const { type, id } = useParams();
  const samsungTypes = [
    'galaxySSeries',
    'galaxyASeries',
    'galaxyFSeries',
    'galaxyZSeries',
    'galaxyTab',
  ];
  const appleTypes = ['iphone', 'airpods', 'mac', 'ipad', 'applewatch'];
  const forcedActiveSection = samsungTypes.includes(type)
    ? 'samsung'
    : appleTypes.includes(type)
      ? 'apple'
      : null;

  const iphoneProductDetails = useSelector(
    (state) => state.products.iphoneData
  ).find((product) => product.id === Number(id));
  console.log(iphoneProductDetails);

  const airpodsProductDetails = useSelector(
    (state) => state.products.airpodsProductDetails
  ).find((product) => product.id === Number(id));
  console.log(airpodsProductDetails);

  const macProductDetails = useSelector(
    (state) => state.products.macProducts
  ).find((product) => product.id === Number(id));
  console.log(macProductDetails);

  const ipadProductDetails = useSelector(
    (state) => state.products.iPadProducts
  ).find((product) => product.id === Number(id));
  console.log(ipadProductDetails);

  const applewatchProductDetails = useSelector(
    (state) => state.products.appleWatchProducts
  ).find((product) => product.id === Number(id));
  console.log(applewatchProductDetails);

  // samsung

  const galaxySSeries = useSelector(
    (state) => state.products.galaxySSeries
  ).find((product) => product.id === Number(id));

  const galaxyASeries = useSelector(
    (state) => state.products.galaxyASeries
  ).find((product) => product.id === Number(id));
  const galaxyFSeries = useSelector(
    (state) => state.products.galaxyFSeries
  ).find((product) => product.id === Number(id));
  const galaxyZSeries = useSelector(
    (state) => state.products.galaxyZSeries
  ).find((product) => product.id === Number(id));
  const galaxyTab = useSelector((state) => state.products.tab).find(
    (product) => product.id === Number(id)
  );

  // oneplus
  const onePlusProductDetails = useSelector(
    (state) => state.products.onePlusData
  ).find((product) => product.id === Number(id));

  // ////////////////////Bellow code ////////////////////////////

  const [mainProductData, setMainProductData] = useState(null);

  useEffect(() => {
    if (type === 'iphone' && iphoneProductDetails) {
      setMainProductData(iphoneProductDetails);
    } else if (type === 'airpods' && airpodsProductDetails) {
      setMainProductData(airpodsProductDetails);
    } else if (type === 'mac' && macProductDetails) {
      setMainProductData(macProductDetails);
    } else if (type === 'ipad' && ipadProductDetails) {
      setMainProductData(ipadProductDetails);
    } else if (type === 'applewatch' && applewatchProductDetails) {
      setMainProductData(applewatchProductDetails);
    } else if (type === 'galaxySSeries' && galaxySSeries) {
      setMainProductData(galaxySSeries);
    } else if (type === 'galaxyASeries' && galaxyASeries) {
      setMainProductData(galaxyASeries);
    } else if (type === 'galaxyFSeries' && galaxyFSeries) {
      setMainProductData(galaxyFSeries);
    } else if (type === 'galaxyZSeries' && galaxyZSeries) {
      setMainProductData(galaxyZSeries);
    } else if (type === 'galaxyTab' && galaxyTab) {
      setMainProductData(galaxyTab);
    } else if (type === 'oneplus' && onePlusProductDetails) {
      setMainProductData(onePlusProductDetails);
    }
  }, [
    type,
    id,
    iphoneProductDetails,
    airpodsProductDetails,
    applewatchProductDetails,
    ipadProductDetails,
    macProductDetails,
    galaxySSeries,
    galaxyASeries,
    galaxyFSeries,
    galaxyZSeries,
    galaxyTab,
    onePlusProductDetails,
  ]);

  // /////////////////////////////////////////////////

  function whatsappChat() {
    const title = `${mainProductData.title}`;
    const productUrl = window.location.href;

    // Encode message text
    const message = `Hey I want to buy this item:\n\nProduct name - ${title}\n${productUrl}`;
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/7005665616?text=${encodedMessage}`, '_blank');
  }
  function facebookProfile() {
    window.open(`https://www.facebook.com/galaxcitygadgets/`, '_blank');
  }
  function instagramProfile() {
    //opening insta
    window.open(`https://www.instagram.com/galaxcitygadgets.store?igsh=MjVkYmRkb3RidWQ5&utm_source=qr/`, '_blank');
  }

  const handleShare = async () => {
    const shareData = {
      text: `Check out this product: ${mainProductData.title}\n`,
      url: window.location.href,
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        alert('Device not Support');
      }
    } catch (error) {
      console.error('Error sharing:', error);
    }
  };

  const [activeTab, setActiveTab] = useState(null);

  useEffect(() => {
    if (mainProductData && mainProductData.specifications) {
      const firstKey = Object.keys(mainProductData.specifications)[0];
      setActiveTab(firstKey);
    }
  }, [mainProductData]);

  // const handleShare = (platform) => {
  //   const productUrl = window.location.href;
  //   const text = encodeURIComponent('Check out this amazing mobile!');

  //   switch (platform) {
  //     case 'facebook':
  //       window.open(
  //         `https://www.facebook.com/sharer/sharer.php?u=${productUrl}`,
  //         '_blank'
  //       );
  //       break;
  //     case 'instagram':
  //       alert(
  //         "Instagram doesn't support direct web sharing. Please share manually."
  //       );
  //       break;
  //     case 'share':
  //       if (navigator.share) {
  //         navigator.share({ title: 'Mobile Product', text, url: productUrl });
  //       } else {
  //         alert('Your browser does not support the Web Share API');
  //       }
  //       break;
  //     case 'link':
  //       navigator.clipboard.writeText(productUrl).then(() => {
  //         alert('Link copied to clipboard!');
  //       });
  //       break;
  //     default:
  //       break;
  //   }
  // };

  // important
  // const specifications = {
  //   Display: (
  //     <p>
  //       <strong>Display:</strong> 6.5" AMOLED, 120Hz
  //     </p>
  //   ),
  //   Memory: (
  //     <p>
  //       <strong>Memory:</strong> 8GB RAM, 128GB Storage
  //     </p>
  //   ),
  //   Camera: (
  //     <p>
  //       <strong>Camera:</strong> 64MP Rear, 32MP Front
  //     </p>
  //   ),
  //   Battery: (
  //     <p>
  //       <strong>Battery:</strong> 5000mAh, Fast Charging
  //     </p>
  //   ),
  //   'Other Specs': (
  //     <>
  //       <p>
  //         <strong>Processor:</strong> Snapdragon 8 Gen 2
  //       </p>
  //       <p>
  //         <strong>OS:</strong> Android 13
  //       </p>
  //       <p>
  //         <strong>Weight:</strong> 180g
  //       </p>
  //       <p>
  //         <strong>Dimensions:</strong> 160 x 75 x 8 mm
  //       </p>
  //       <p>
  //         <strong>Connectivity:</strong> 5G, Wi-Fi 6, Bluetooth 5.2
  //       </p>
  //       <p>
  //         <strong>SIM:</strong> Dual SIM (Nano)
  //       </p>
  //     </>
  //   ),
  // };
  const parsePrice = (price) => {
    return parseFloat(price?.toString().replace(/[^0-9.]/g, '')) || 0;
  };

  const hasDiscount = () => {
    const original = parsePrice(mainProductData?.originalPrice);
    const discounted = parsePrice(mainProductData?.discountedPrice);
    return original > discounted && discounted > 0;
  };

  const isUltra3Watch =
    mainProductData?.title === 'Apple Watch Ultra 3' ||
    mainProductData?.title === 'Ultra 3 (Natural Titanium)';
  const isS26Ultra = mainProductData?.title?.includes('Galaxy S26 Ultra');
  const isS26Plus = mainProductData?.title?.includes('Galaxy S26 Plus');
  const isS26Base =
    mainProductData?.title?.includes('Galaxy S26') && !isS26Ultra && !isS26Plus;

  const ultra3DesignCards = [
    {
      title: '49mm. Power in every pixel.',
      description:
        'Wide-angle OLEDs make the display brighter when viewed at an angle. Power-efficient LTPO3 technology allows you to see ticking seconds on watch faces.',
      image: ultra3DetailImage1,
      accent: 'light',
      layout: 'pixel',
    },
    {
      title: 'Charge less. Do more.',
      description:
        'The longest battery life of any Apple Watch. Up to 42 hours of normal use.',
      image: ultra3DetailImage2,
      accent: 'green',
      layout: 'battery',
    },
    {
      title: 'Titanium. Tough all around.',
      description:
        'Built to last with a rugged titanium case and a display crafted from sapphire crystal, one of the strongest naturally occurring materials on Earth.',
      image: ultra3DetailImage3,
      accent: 'light',
      layout: 'stacked',
    },
    {
      title: 'Water and dust resistance.',
      description:
        'Ultra 3 is rated WR100 for recreational scuba diving to 40 metres and high-speed water sports. It is also IP6X dust resistant.',
      image: ultra3DetailImage4,
      accent: 'light',
      layout: 'split',
    },
    {
      title: 'Stay connected.',
      descriptionLines: [
        'All you need is your watch.',
        'Take and make calls, and download music and podcasts on the go.',
        'And thanks to a new 5G modem and antenna architecture,',
        'Ultra 3 provides better coverage in areas with weak reception.',
      ],
      image: ultra3DetailImage5,
      accent: 'steel',
      layout: 'stay',
    },
    {
      title: 'Action button.',
      description:
        'One quick press gives you precise, physical control over a variety of customizable functions like starting a workout, marking a segment or turning on the flashlight.',
      image: ultra3DetailImage6,
      accent: 'orange',
      layout: 'action',
    },
    {
      title: 'Your health. On your wrist.',
      description:
        'Advanced sensors track your sleep, analyzing duration, consistency, and stages to give a clear sleep score. Wrist temperature provides cycle insights, while continuous and on-demand blood oxygen readings give a complete view of your wellness.',
      image: ultra3DetailImage7,
      accent: 'light',
      layout: 'health-grid',
    },
    {
      title: 'Your health. On your wrist.',
      description:
        'See your daily health at a glance in the Vitals app, tracking heart rate, respiratory rate, wrist temperature, blood oxygen, and sleep. Take an ECG anytime and share it with your doctor, and get notified of unusual heart activity.',
      image: ultra3DetailImage8,
      accent: 'orange',
      layout: 'health-vitals',
    },
    {
      title: 'Safety',
      subtitle: 'A real lifeline.',
      description:
        'Packed with innovative safety firsts, Apple Watch Ultra 3 has your back. It is designed to summon help when you need it most, even if you cannot reach your iPhone.',
      image: ultra3DetailImage9,
      accent: 'safety',
      layout: 'safety-image',
    },
    {
      title: 'Shop Watch Straps',
      description: '',
      accent: 'light',
      image: ultra3DetailImage10,
      layout: 'straps-bottom',
    },
  ];

  const s26UltraHighlightCards = [
    {
      type: 'refined-design',
      image: s26UltraHighlight1,
    },
    {
      type: 'privacy-display',
      image: s26UltraHighlight2,
    },
    {
      type: 'pro-cameras',
      image: s26UltraHighlight3,
    },
    {
      type: 'vapor-chamber',
      image: s26UltraHighlight4,
    },
    {
      type: 'processor',
      image: s26UltraHighlight5,
    },
    {
      type: 'battery',
      image: s26UltraHighlight6,
    },
    {
      type: 'horizontal-lock',
      image: s26UltraHighlight7,
    },
    {
      type: 'galaxy-ai',
      image: s26UltraHighlight8,
    },
  ];

  const s26BaseHighlightCards = [
    {
      type: 'refined-design',
      image: s26Info1,
      title: 'Designed to redefine.',
      subtitle: '7.2mm thickness',
      description:
        'Meet Galaxy S26 and S26+, unified by a single corner radius that flows across every model and feels perfect in any hand.',
    },
    {
      type: 'display-size',
      image: s26Info2,
      title: 'Display Size.',
      leftLabel: 'S26+',
      leftValue: '6.65 inches',
      rightLabel: 'S26',
      rightValue: '6.27 inches',
    },
    {
      type: 'processor',
      image: s26UltraHighlight5,
      title: 'Most powerful processor, customized for Galaxy.',
      subtitle: 'Snapdragon 8 Elite Gen 5 for Galaxy',
      description:
        'Powered by Snapdragon® 8 Elite Gen 5 for Galaxy, it delivers amplified gaming performance with fast, smooth and highly responsive gameplay.',
    },
    {
      type: 'battery',
      image: s26UltraHighlight6,
      title: '5000 mAh Battery',
      subtitle: 'All-day power with fast charging',
      batteryHours: '30hrs',
      chargePercent: '69%',
    },
    
    {
      type: 'pro-cameras',
      image: s26Info5,
      title: 'Amazing camera',
      // subtitle: 'From night shots to action scenes.',
    },
    {
      type: 'vapor-chamber',
      image: s26UltraHighlight4,
      title: 'Play longer. Stay cooler',
      subtitle: 'Cooler performance for longer.',
      description:
        'The new Vapor Chamber design, heat is dissipated faster and more efficiently than ever before. Alongside the tailored thermal interface material (TIM), the enhanced cooling system enables 29% greater thermal performance.',
    },   
    
    {
      type: 'horizontal-lock',
      image: s26UltraHighlight7,
      title: 'Horizontal Lock',
      subtitle: 'Super Steady video that stays level.',
      description: 'Super Steady’s Horizontal Lock blends wide optical angles with gyro and acceleration sensors to detect gravity and keep footage level—even through full 360° rotation. It ensures smooth, shake‑free video whether you’re on rough terrain or moving at top speed.'
    },
    {
      type: 'galaxy-ai',
      image: s26UltraHighlight8,
      title: 'Galaxy AI',
      subtitle: 'Smart features on-device.',
      bullets: [
        'Photo Assist → edit or remove objects with text prompts.',
        'Creative Studio → make stickers or art from sketches/photos.',
        'Now Nudge → smart shortcuts based on screen context.',
        'Now Brief → quick personalized updates and reminders.',
        'Finder → search saved info like notes or reservations.',
        'Bixby → natural language for settings and searches.',
        'Privacy → on-device AI with Knox Vault protection.',
      ],
    },
  ];

  return (
    <>
      <ScrollTop />
      <Nav forcedActiveSection={forcedActiveSection} />
      <RedirectBack steps={-1} />
      {!mainProductData ? (
        <div
          style={{
            height: '70vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '28px',
          }}
        >
          Loading Product Details...
        </div>
      ) : (
        <div className="iphone-detail-page">
          {/* Left - Product Image Carousel */}
          <div className="iphone-detail-left">
            <Swiper
              modules={[Navigation, Pagination]}
              navigation
              pagination={{ clickable: true }}
              className={`swiper-custom ${isUltra3Watch ? 'swiper-ultra3' : ''} ${
                isS26Ultra ? 'swiper-s26-ultra' : ''
              }`}
            >
              {mainProductData.images.map((src, index) => (
                <SwiperSlide key={index}>
                  <img
                    src={src}
                    className="product-image"
                    alt={`image${index}`}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          {/* Right - Product Info */}
          <div className="iphone-detail-right">
            <div className="title-row">
              <h1 className="product-title">{mainProductData.title}</h1>
              <Share2
                className="social-icon share"
                onClick={() => handleShare()}
              />
            </div>

            <div className="price-row">
              {hasDiscount() && mainProductData.originalPrice && (
                <span className="original-price">
                  &#8377;{mainProductData.originalPrice}
                </span>
              )}

              <span className="discounted-price">
                &#8377;{mainProductData.discountedPrice}
              </span>
              {hasDiscount() && (
                <span className="offer-text">
                  &#8377;
                  {parsePrice(mainProductData.originalPrice) -
                    parsePrice(mainProductData.discountedPrice)}{' '}
                  off
                </span>
              )}
            </div>

            <div className="color-options">
              <span>Color:</span>
              <div className="color-text ">
                <p>
                  {mainProductData.colors.map((color, index) => {
                    const isLast = index === mainProductData.colors.length - 1;
                    return `${color}${isLast ? '.' : ', '}`;
                  })}
                </p>
              </div>
            </div>
            {mainProductData.offers.length > 0 && (
              <div className="offers-box">
                {mainProductData.offers.map((offer, index) => (
                  <p key={`${offer.label}-${offer.value}-${index}`}>
                    <strong>{offer.label}</strong> &nbsp; {offer.value}
                  </p>
                ))}
              </div>
            )}

            <div className="button-row">
              <button
                className="apl-btn buy-button"
                onClick={() => whatsappChat()}
              >
                Order via WhatsApp
              </button>
              {/* <button className="btn cart-btn">Add to Cart</button> */}
            </div>

            {/* Best And Important */}
            <div className="spec-section">
              <div className="spec-tabs">
                {Object.keys(mainProductData.specifications).map((key) => (
                  <button
                    key={key}
                    className={`tab-button ${
                      activeTab === key ? 'active-tab' : ''
                    }`}
                    onClick={() => setActiveTab(key)}
                  >
                    {key}
                  </button>
                ))}
              </div>
              {/* <div className="spec-content">
              {specifications[activeTab]}
              {Object.keys(iphoneProductDetails.specifications).map((key) => (
                <p>
                  <strong>{key}:</strong>
                  {iphoneProductDetails.specifications[key]}
                </p>
              ))}
            </div> */}

              {/* important  */}
              <div className="spec-content">
                {mainProductData.specifications &&
                mainProductData.specifications[activeTab] ? (
                  typeof mainProductData.specifications[activeTab] ===
                  'string' ? (
                    <p>
                      <strong>{activeTab}:</strong>{' '}
                      {mainProductData.specifications[activeTab]}
                    </p>
                  ) : (
                    /*   Object.entries(mainProductData.specifications[activeTab]).map(
                      ([subKey, subVal]) => (
                        <p key={subKey}>
                          <strong>{subKey}:</strong> {subVal}
                        </p>
                      )
                    ) */
                    mainProductData.specifications[activeTab].map(
                      (data, index) => {
                        console.log(data);
                        return <li key={index}>{data}</li>;
                      }
                    )
                  )
                ) : (
                  <p>________________________________</p>
                )}
              </div>
            </div>
            <div className="social-icons">
              <Facebook
                className="social-icon facebook"
                onClick={() => facebookProfile()}
              />
              <Instagram
                className="social-icon instagram"
                onClick={() => instagramProfile()}
              />

              {/* <LinkIcon
              className="social-icon link"
              onClick={() => handleCopyLink()}
            /> */}
            </div>
          </div>

          {isUltra3Watch && (
            <div className="ultra3-design-section">
              <h2 className="ultra3-design-title">Ultra 3 Highlights</h2>
              {ultra3DesignCards.map((card) => (
                <div
                  key={card.title}
                  className={`design-card design-card-${card.accent} design-card-${card.layout}`}
                >
                  {card.layout === 'stay' ? (
                    <>
                      <div className="design-card-copy">
                        <h2>{card.title}</h2>
                        {card.subtitle && <h3 className="design-card-subtitle">{card.subtitle}</h3>}
                        {card.stat && <div className="design-card-stat">{card.stat}</div>}
                      </div>
                      <div className="design-card-image-wrap">
                        <img
                          src={card.image}
                          alt={card.title}
                          className="design-card-image"
                        />
                      </div>
                      <p className="design-card-description">
                        {card.descriptionLines.map((line, index) => (
                          <React.Fragment key={`${card.title}-line-${index}`}>
                            {line}
                            {index < card.descriptionLines.length - 1 && <br />}
                          </React.Fragment>
                        ))}
                      </p>
                    </>
                  ) : card.layout === 'health-grid' || card.layout === 'health-vitals' || card.layout === 'straps-bottom' ? (
                    <>
                      <div className="design-card-copy">
                        <h2>{card.title}</h2>
                        {card.subtitle && <h3 className="design-card-subtitle">{card.subtitle}</h3>}
                        {card.stat && <div className="design-card-stat">{card.stat}</div>}
                      </div>
                      <div className="design-card-image-wrap">
                        <img
                          src={card.image}
                          alt={card.title}
                          className="design-card-image"
                        />
                      </div>
                      {card.description && (
                        <p className="design-card-description">{card.description}</p>
                      )}
                    </>
                  ) : card.layout === 'safety-image' ? (
                    <>
                      <div className="design-card-image-wrap">
                        <img
                          src={card.image}
                          alt={card.title}
                          className="design-card-image"
                        />
                      </div>
                      <div className="design-card-copy">
                        <h2>{card.title}</h2>
                        {card.subtitle && <h3 className="design-card-subtitle">{card.subtitle}</h3>}
                        {card.description && <p>{card.description}</p>}
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="design-card-copy">
                        <h2>{card.title}</h2>
                        {card.subtitle && <h3 className="design-card-subtitle">{card.subtitle}</h3>}
                        {card.stat && <div className="design-card-stat">{card.stat}</div>}
                        {card.descriptionLines ? (
                          <p>
                            {card.descriptionLines.map((line, index) => (
                              <React.Fragment key={`${card.title}-line-${index}`}>
                                {line}
                                {index < card.descriptionLines.length - 1 && <br />}
                              </React.Fragment>
                            ))}
                          </p>
                        ) : (
                          card.description && <p>{card.description}</p>
                        )}
                      </div>
                      <div className="design-card-image-wrap">
                        {card.visual === 'sos' ? (
                      <div className="design-card-sos-visual">
                        <div className="design-card-sos-ring ring-1">
                          <div className="design-card-sos-ring ring-2">
                            <div className="design-card-sos-ring ring-3">
                              <div className="design-card-sos-core">SOS</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : card.imageSet ? (
                      <div className="design-card-image-set">
                        {card.imageSet.map((imageSrc, index) => (
                          <img
                            key={`${card.title}-${index}`}
                            src={imageSrc}
                            alt={`${card.title} ${index + 1}`}
                            className="design-card-image"
                          />
                        ))}
                      </div>
                    ) : (
                      <img
                        src={card.image}
                        alt={card.title}
                        className={`design-card-image ${
                          card.imageVariant ? `design-card-image-${card.imageVariant}` : ''
                        }`}
                      />
                    )}
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>
          )}

          {isS26Ultra && (
            <div className="s26-ultra-highlights-section">
              {s26UltraHighlightCards.map((card, index) => (
                <div
                  key={`s26-ultra-highlight-${index + 1}`}
                  className={`s26-ultra-highlight-card s26-ultra-highlight-card-${card.type}`}
                >
                  {card.type === 'refined-design' ? (
                    <>
                      <div className="s26-ultra-highlight-copy">
                        <h3>S26 Ultra</h3>
                        <h2>Refined Design</h2>
                        <p>
                          Introducing a new glass camera island that flows seamlessly into
                          the device as part of a more refined design.
                        </p>
                      </div>
                      <img
                        src={card.image}
                        alt="S26 Ultra Refined Design"
                        className="s26-ultra-highlight-image s26-ultra-highlight-image-refined"
                      />
                    </>
                  ) : card.type === 'privacy-display' ? (
                    <>
                      <div className="s26-ultra-highlight-copy">
                        <h2 className="s26-privacy-title">
                          The world&apos;s first
                          <br />
                          <strong>Privacy Display</strong> on mobile.
                        </h2>
                        <ul className="s26-privacy-points">
                          <li>
                            <strong>Viewing angle control</strong> → looks normal straight on,
                            dims/hides from the side.
                          </li>
                          <li>
                            <strong>Customizable privacy</strong> → hide full screen, chosen
                            apps, notifications, or sensitive inputs (PINs/passwords).
                          </li>
                        </ul>
                      </div>
                      <img
                        src={card.image}
                        alt="S26 Ultra Privacy Display"
                        className="s26-ultra-highlight-image s26-ultra-highlight-image-privacy"
                      />
                    </>
                  ) : card.type === 'pro-cameras' ? (
                    <>
                      <div className="s26-ultra-highlight-copy">
                        <h2 className="s26-pro-title">Pro Cameras</h2>
                      </div>
                      <div className="s26-pro-image-wrap">
                        <img
                          src={card.image}
                          alt="S26 Ultra Pro Cameras"
                          className="s26-ultra-highlight-image s26-ultra-highlight-image-pro"
                        />
                      </div>
                    </>
                  ) : card.type === 'vapor-chamber' ? (
                    <>
                      <div className="s26-ultra-highlight-copy">
                        {card.title ? (
                          <>
                            <h2 className="s26-vapor-title">{card.title}</h2>
                            {card.subtitle && (
                              <p className="s26-vapor-subtitle">{card.subtitle}</p>
                            )}
                          </>
                        ) : (
                          <h2 className="s26-vapor-title">
                            <span>Largest</span>
                            <br />
                            <strong>Vapor Chamber</strong> ever
                          </h2>
                        )}
                      </div>
                      <div className="s26-vapor-image-wrap">
                        <img
                          src={card.image}
                          alt={card.title || 'S26 Ultra Largest Vapor Chamber'}
                          className="s26-ultra-highlight-image s26-ultra-highlight-image-vapor"
                        />
                      </div>
                      <p className="s26-vapor-description">
                        {card.description ||
                          'The new Vapor Chamber design, heat is dissipated faster and more efficiently than ever before. Alongside the tailored thermal interface material (TIM), the enhanced cooling system enables 21% greater thermal performance.'}
                      </p>
                    </>
                  ) : card.type === 'processor' ? (
                    <>
                      <div className="s26-ultra-highlight-copy">
                        <h2 className="s26-processor-title">
                          Most powerful <strong>processor</strong>,
                          <br />
                          customized for <strong>Galaxy</strong>.
                        </h2>
                      </div>
                      <div className="s26-processor-visuals">
                        <img
                          src={card.image}
                          alt="S26 Ultra Processor"
                          className="s26-ultra-highlight-image s26-ultra-highlight-image-processor"
                        />
                      </div>
                      <p className="s26-processor-description">
                        Powered by Snapdragon® 8 Elite Gen 5 for Galaxy, it delivers
                        amplified gaming performance with fast, smooth and highly
                        responsive gameplay.
                      </p>
                    </>
                  ) : card.type === 'battery' ? (
                    <>
                      <div className="s26-ultra-highlight-copy">
                        <h2 className="s26-battery-title">5000 mAh Battery</h2>
                      </div>
                      <div className="s26-battery-layout">
                        <div className="s26-battery-left">
                          <div className="s26-battery-big">31hrs</div>
                          <div className="s26-battery-small">of video playback</div>
                        </div>
                        <img
                          src={card.image}
                          alt="S26 Ultra Battery Performance"
                          className="s26-ultra-highlight-image s26-ultra-highlight-image-battery"
                        />
                        <div className="s26-battery-right">
                          <div className="s26-battery-up">
                            Up to <strong className="s26-battery-percent">75%</strong>
                          </div>
                          <div className="s26-battery-mid">charge in</div>
                          <div className="s26-battery-down">
                            around <strong className="s26-battery-mins">30 mins</strong>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : card.type === 'horizontal-lock' ? (
                    <>
                      <div className="s26-ultra-highlight-copy">
                        <h2 className="s26-horizontal-title">Horizontal Lock</h2>
                        <p className="s26-horizontal-subtitle">
                          Super Steady Video. Even on the go
                        </p>
                      </div>
                      <div className="s26-horizontal-image-wrap">
                        <img
                          src={card.image}
                          alt="S26 Ultra Horizontal Lock"
                          className="s26-ultra-highlight-image s26-ultra-highlight-image-horizontal"
                        />
                      </div>
                      <p className="s26-horizontal-description">
                        Super Steady&apos;s Horizontal Lock blends wide optical angles with
                        gyro and acceleration sensors to detect gravity and keep footage
                        level, even through full 360° rotation. It ensures smooth,
                        shake-free video whether you&apos;re on rough terrain or moving at
                        top speed.
                      </p>
                    </>
                  ) : card.type === 'galaxy-ai' ? (
                    <>
                      <div className="s26-ultra-highlight-copy s26-galaxy-ai-copy">
                        <h2 className="s26-galaxy-ai-title">
                          Galaxy AI
                          <img
                            src={card.image}
                            alt="Galaxy AI icon"
                            className="s26-galaxy-ai-icon"
                          />
                        </h2>
                        <ul className="s26-galaxy-ai-points">
                          <li>
                            <strong>Photo Assist</strong> → edit or remove objects with text
                            prompts.
                          </li>
                          <li>
                            <strong>Creative Studio</strong> → make stickers or art from
                            sketches/photos.
                          </li>
                          <li>
                            <strong>Now Nudge</strong> → smart shortcuts based on screen
                            context.
                          </li>
                          <li>
                            <strong>Now Brief</strong> → quick personalized updates and
                            reminders.
                          </li>
                          <li>
                            <strong>Finder</strong> → search saved info like notes or
                            reservations.
                          </li>
                          <li>
                            <strong>Bixby</strong> → natural language for settings and
                            searches.
                          </li>
                          <li>
                            <strong>Privacy</strong> → on-device AI with Knox Vault
                            protection.
                          </li>
                        </ul>
                      </div>
                    </>
                  ) : (
                    <img
                      src={card.image}
                      alt={`S26 Ultra Highlight ${index + 1}`}
                      className="s26-ultra-highlight-image"
                    />
                  )}
                </div>
              ))}
            </div>
          )}

          {(isS26Base || isS26Plus) && (
            <>
              <div className="s26-base-card-row">
                {['refined-design', 'display-size'].map((type) => {
                  const card = s26BaseHighlightCards.find((item) => item.type === type);
                  if (!card) return null;
                  const highlightImage = card.image;
                  return (
                    <div
                      key={`s26-base-highlight-${card.type}`}
                      className={`s26-ultra-highlight-card s26-ultra-highlight-card-${card.type} s26-base-highlight-card s26-base-highlight-card-${card.type}`}
                    >
                      {card.type === 'refined-design' ? (
                        <>
                          <div className="s26-base-refined-top-copy">
                            <h3>{card.title}</h3>
                            <h2>{card.subtitle}</h2>
                          </div>
                          <img
                            src={highlightImage}
                            alt={card.title}
                            className="s26-ultra-highlight-image s26-ultra-highlight-image-refined"
                          />
                          <div className="s26-base-refined-bottom-copy">
                            <p>{card.description}</p>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="s26-display-size-copy">
                            <h2 className="s26-display-title">{card.title}</h2>
                          </div>
                          <div className="s26-display-size-grid">
                            <div className="s26-display-size-side s26-display-size-left">
                              <span className="s26-display-size-label">{card.leftLabel}</span>
                              <span className="s26-display-size-value">{card.leftValue}</span>
                            </div>
                            <div className="s26-display-size-center">
                              <img
                                src={highlightImage}
                                alt={card.title}
                                className="s26-ultra-highlight-image s26-ultra-highlight-image-display"
                              />
                            </div>
                            <div className="s26-display-size-side s26-display-size-right">
                              <span className="s26-display-size-label">{card.rightLabel}</span>
                              <span className="s26-display-size-value">{card.rightValue}</span>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  );
                })}
              </div>
              <div className="s26-base-highlights-section">
                {s26BaseHighlightCards
                  .filter((card) => !['refined-design', 'display-size'].includes(card.type))
                  .map((card, index) => {
                    const highlightImage = card.image;
                    return (
                      <div
                        key={`s26-base-highlight-${index + 1}`}
                        className={`s26-ultra-highlight-card s26-ultra-highlight-card-${card.type} s26-base-highlight-card`}
                      >
                        {card.type === 'privacy-display' ? (
                          <>
                            <div className="s26-ultra-highlight-copy">
                              <h2 className="s26-privacy-title">
                                {card.title}
                                <br />
                                <strong>{card.subtitle}</strong>
                              </h2>
                              <ul className="s26-privacy-points">
                                {card.bullets.map((bullet, idx) => (
                                  <li key={idx}>{bullet}</li>
                                ))}
                              </ul>
                            </div>
                            <img
                              src={highlightImage}
                              alt={card.title}
                              className="s26-ultra-highlight-image s26-ultra-highlight-image-privacy"
                            />
                          </>
                        ) : card.type === 'pro-cameras' ? (
                          <>
                            <div className="s26-ultra-highlight-copy">
                              <h2 className="s26-pro-title">{card.title}</h2>
                              {card.subtitle && <p className="s26-pro-subtitle">{card.subtitle}</p>}
                            </div>
                            <div className="s26-pro-image-wrap">
                              <img
                                src={highlightImage}
                                alt={card.title}
                                className="s26-ultra-highlight-image s26-ultra-highlight-image-pro"
                              />
                            </div>
                          </>
                        ) : card.type === 'vapor-chamber' ? (
                          <>
                            <div className="s26-ultra-highlight-copy">
                              {card.title ? (
                                <>
                                  <h2 className="s26-vapor-title">{card.title}</h2>
                                  {card.subtitle && (
                                    <p className="s26-vapor-subtitle">{card.subtitle}</p>
                                  )}
                                </>
                              ) : (
                                <h2 className="s26-vapor-title">
                                  <span>Largest</span>
                                  <br />
                                  <strong>Vapor Chamber</strong> ever
                                </h2>
                              )}
                            </div>
                            <div className="s26-vapor-image-wrap">
                              <img
                                src={highlightImage}
                                alt={card.title}
                                className="s26-ultra-highlight-image s26-ultra-highlight-image-vapor"
                              />
                            </div>
                            <p className="s26-vapor-description">{card.description}</p>
                          </>
                        ) : card.type === 'processor' ? (
                          <>
                            <div className="s26-ultra-highlight-copy">
                              <h2 className="s26-processor-title">
                                Most powerful <strong>processor</strong>, customized for <strong>Galaxy</strong>.
                              </h2>
                            </div>
                            <div className="s26-processor-visuals">
                              <img
                                src={highlightImage}
                                alt={card.title}
                                className="s26-ultra-highlight-image s26-ultra-highlight-image-processor"
                              />
                            </div>
                            {card.description && (
                              <p className="s26-processor-description">{card.description}</p>
                            )}
                          </>
                        ) : card.type === 'battery' ? (
                          <>
                            <div className="s26-ultra-highlight-copy">
                              <h2 className="s26-battery-title">{card.title}</h2>
                            </div>
                            <div className="s26-battery-layout">
                              <div className="s26-battery-left">
                                <div className="s26-battery-big">{card.batteryHours || '30hrs'}</div>
                                <div className="s26-battery-small">of video playback</div>
                              </div>
                              <img
                                src={highlightImage}
                                alt={card.title}
                                className="s26-ultra-highlight-image s26-ultra-highlight-image-battery"
                              />
                              <div className="s26-battery-right">
                                <div className="s26-battery-up">
                                  Up to <strong className="s26-battery-percent">{card.chargePercent || '69%'}</strong>
                                </div>
                                <div className="s26-battery-mid">charge in</div>
                                <div className="s26-battery-down">
                                  around <strong className="s26-battery-mins">30 mins</strong>
                                </div>
                              </div>
                            </div>
                          </>
                        ) : card.type === 'horizontal-lock' ? (
                          <>
                            <div className="s26-ultra-highlight-copy">
                              <h2 className="s26-horizontal-title"><strong>{card.title}</strong></h2>
                              <p className="s26-horizontal-subtitle">{card.subtitle}</p>
                            </div>
                            <div className="s26-horizontal-image-wrap">
                              <img
                                src={highlightImage}
                                alt={card.title}
                                className="s26-ultra-highlight-image s26-ultra-highlight-image-horizontal"
                              />
                            </div>
                            <p className="s26-horizontal-description">{card.description}</p>
                          </>
                        ) : card.type === 'galaxy-ai' ? (
                          <>
                            <div className="s26-ultra-highlight-copy s26-galaxy-ai-copy">
                              <h2 className="s26-galaxy-ai-title">
                                {card.title}
                                <img
                                  src={highlightImage}
                                  alt="Galaxy AI icon"
                                  className="s26-galaxy-ai-icon"
                                />
                              </h2>
                              <ul className="s26-galaxy-ai-points">
                                {card.bullets.map((bullet, idx) => {
                                  const [label, detail] = bullet.split('→');
                                  return (
                                    <li key={idx}>
                                      <strong>{label?.trim()}</strong>
                                      {detail ? ` → ${detail.trim()}` : ''}
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                          </>
                        ) : (
                          <img
                            src={highlightImage}
                            alt={card.title}
                            className="s26-ultra-highlight-image"
                          />
                        )}
                      </div>
                    );
                  })}
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
}
